// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1kpeu","notes":"Notes_notes__2p8Ys","note":"Notes_note__3MLZl","markdown":"Notes_markdown__2pU2d"};